import { useRef, useEffect } from 'react';
import { gsap } from 'gsap';

interface MarqueeProps {
  children: React.ReactNode;
  speed?: number;
  direction?: 'left' | 'right';
  className?: string;
}

export function Marquee({
  children,
  speed = 50,
  direction = 'left',
  className = '',
}: MarqueeProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!innerRef.current || !containerRef.current) return;

    const inner = innerRef.current;
    const contentWidth = inner.scrollWidth / 2;

    // Set initial position based on direction
    const startX = direction === 'left' ? 0 : -contentWidth;
    const endX = direction === 'left' ? -contentWidth : 0;

    gsap.set(inner, { x: startX });

    const duration = contentWidth / speed;

    gsap.to(inner, {
      x: endX,
      duration,
      ease: 'none',
      repeat: -1,
    });
  }, [speed, direction]);

  return (
    <div
      ref={containerRef}
      className={`overflow-hidden whitespace-nowrap ${className}`}
    >
      <div ref={innerRef} className="inline-flex">
        {/* Original */}
        <div className="flex items-center gap-8">{children}</div>
        {/* Duplicate for seamless loop */}
        <div className="flex items-center gap-8 ml-8">{children}</div>
      </div>
    </div>
  );
}
